import { render, staticRenderFns } from "./CompetitorsDirectory.vue?vue&type=template&id=16b846a6&scoped=true"
import script from "./CompetitorsDirectory.vue?vue&type=script&lang=ts"
export * from "./CompetitorsDirectory.vue?vue&type=script&lang=ts"
import style0 from "./CompetitorsDirectory.vue?vue&type=style&index=0&id=16b846a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b846a6",
  null
  
)

export default component.exports